import styled from "@emotion/styled";

export const LoginContainer = styled.div`
  margin: auto;
  padding: 80px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  overflow: auto;
`;

export const List = styled.ul`
  list-style: none;
  padding-left: 0;
  margin-top: 40px;
  margin-bottom: 60px;
`;
export const ListItem = styled.li`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  font-size: ${(props) => props.theme.font.h3.fontSize};
  font-weight: ${(props) => props.theme.font.h3.fontWeight};
  font-family: ${(props) => props.theme.font.h3.fontFamily};
  color: ${(props) => props.theme.colors.text.seconday};
  @media (max-width: 768px) {
    font-size: ${(props) => props.theme.font.body.fontSize};
  }
`;

export const LogoStyle = {
  height: "40px",
  width: "209px",
  marginBottom: "75px",
};
